<template>
    <div class="page">
        <div class="banner"></div>
        <sm-breadcrumb :data-list="[{name:'首页',path:'home'},{name:'新闻动态'}]"/>
        <div class="min">
            <div class="bot"
                v-for="(item, index) in groupList[this.currentPage]"
                :key="index"
                :class="index % 2 === 0 ? '' : 'mar'"
                @click="pageClick(index+((currentPage)*10))">
                <div style="display: flex">
                    <div class="le">
                        <p class="p1">{{ item.day }}</p>
                        <p class="p2"></p>
                        <p class="p3">{{ item.year }}-{{ item.month }}</p>
                    </div>
                    <p class="ri">{{ item.titleSmall }}</p>
                </div>
                <i class="el-icon-arrow-right"></i>
            </div>
            <div style="clear:both"></div>
        </div>
        <div style="display: flex;justify-content: center">
            <el-pagination
                :page-size="10"
                :page-count="totalPage"
                layout="prev, pager, next"
                :total="dataList.length" 
                @current-change="pageCurrentChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import SmBreadcrumb from "@/components/SmBreadcrumb";

export default {
    components: {SmBreadcrumb},
    data() {
        return {
            dataList: [],
            totalPage: 0,
            groupList: [[]],
            currentPage: 0
        }
    },
    created() {
        this.dataList = this.$newsList
        this.groupList = this.getGroupList();
    },
    methods: {
        pageClick: function (index) {
            this.$router.push({
                    path:'new',
                    query: {
                        page:index
                    }
                });
            document.documentElement.scrollTop = 0;
        },
        getGroupList() {
            let dataList = JSON.parse(JSON.stringify(this.dataList));
            this.totalPage = ((dataList.length / 10) | 0) + 1;
            if (dataList.length % 10 === 0) {
                this.totalPage = this.totalPage - 1;
            }
            let arr = [];
            for (let i = 0; i < this.totalPage; i++) {
                arr[i] = dataList.splice(0, 10);
            }
            return arr;
        },
        pageCurrentChange(__currentPage) {
            this.currentPage = __currentPage - 1;
        },
    }
}
</script>

<style lang="scss" scoped>
.banner {
    height: 2.9rem;
    width: 100%;
    background: url("../../assets/images/about/news/xw.jpg");
    background-size: 100% 100%;
}

.news-list {
    width: 1200px;
    margin: 10px auto;

    .list-item {
        height: 45px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title {
            width: 1050px;
            cursor: pointer;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;

            &:hover {
                color: #E71120;
            }
        }
    }
}

.min {
    width: 12rem;
    margin: .2rem auto;

    .bot {
        border: 1px solid #eee;
        margin: 0 0.5rem 0.34rem 0;
        height: 1.4rem;
        padding-top: 0.25rem;
        width: 5.5rem;
        background: #fff;
        position: relative;
        float: left;
        cursor: pointer;

        .p1 {
            font-size: 0.3rem;
        }

        .p2 {
            width: 0.3rem;
            height: 1px;
            background: #e70f20;
            margin-top: 0.03rem;
        }

        .p3 {
            font-size: 0.14rem;
            color: #939393;
            line-height: 0.4rem;
        }

        .le {
            padding: 0.15rem 0 0 0.42rem;
            width: 1.24rem;
        }

        .ri {
            width: 5rem;
            height: 0.88rem;
            font-size: 0.2rem;
            text-align: justify;
            border-left: 1px solid #eaeaea;
            padding: 0.08rem 0.35rem 0 0.3rem;
        }

        i {
            position: absolute;
            bottom: 0.08rem;
            right: 0.07rem;
            font-size: 0.26rem;
            color: #b5b5b5;
        }
    }

    div.mar {
        margin-right: 0;
    }
}

</style>
